import { Component } from '@angular/core';
import { RepositoryService } from './../shared/services/repository.service';
import { RiskUser } from './../_interfaces/RiskUser.model';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  isExpanded = false;
  public user: RiskUser;

  constructor(private repository: RepositoryService) {

  }

  ngOnInit() {
    this.user = new RiskUser;
    this.user.superAdmin = 0;

    this.repository.GetMyUserRemote()
      .subscribe(res => {
      this.user = res as RiskUser;
    });;

  }


  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  getMyUser() {

    let apiAddress: string = `Users/MyUser`; 
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.user = res as RiskUser;
      });
    
  }
}
